import React from "react";
import "./About.css";
import AboutImg from "../../../src/images/welcome.png";
import Button from "../../Components/Button/Button"
const About = () => {
  return (
    <>
      <div className="about-cnt">
        <div className="about-heading-wrapper">
          <h1 className="about-heading">Welcome To Our Company</h1>
          <div className="underline"></div>
        </div>
        <div className="about-image-wrapper">
          <img className="about-img" src={AboutImg} alt="" />
        </div>
        <div className="about-text-wrapper">
          <div className="about-text">
            dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magnaaliqua.Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
            commodo consequat.Duisaute irure dolor in reprehenderit in voluptate
            velit esse cillum dolore eu
          </div>
          <Button/>
        </div>
      </div>
    </>
  );
};

export default About;
